import { render, staticRenderFns } from "./newAdvertisee.vue?vue&type=template&id=e878a07a&scoped=true&"
import script from "./newAdvertisee.vue?vue&type=script&lang=js&"
export * from "./newAdvertisee.vue?vue&type=script&lang=js&"
import style0 from "./newAdvertisee.vue?vue&type=style&index=0&id=e878a07a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e878a07a",
  null
  
)

export default component.exports